export const Bio = {
  name: "Shujauddin Qadri",
  roles: ["Android Developer", "Web Developer", "React-Native Developer"],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/gh-shujauddin",
  resume:
    "https://drive.google.com/file/d/15xtP8ueEGOL-43tKTFVbQ1qjCIqg4jhJ/view?usp=drivesdk",
  linkedin: "https://www.linkedin.com/in/shqadri/",
  twitter: "https://twitter.com/sh__qadri",
  insta: "https://www.instagram.com/qadri.81/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "AWS Amplify",
        image:
          "https://seeklogo.com/images/A/aws-amplify-logo-D68DDB5AB1-seeklogo.com.png",
      },
      {
        name: "MongoDB",
        image: "https://cdn.worldvectorlogo.com/logos/mongodb-icon-1.svg",
      },
    ],
  },
  {
    title: "Android / Mobile",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Kotlin",
        image:
          "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      },
      {
        name: "Jetpack Compose",
        image:
          "https://github.com/gh-shujauddin/public-images/assets/73093103/0e3906b3-e376-466f-ab61-c8975555e066",
      },
      {
        name: "XML",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name: "React Native",
        image: "https://plavno.io/media/img/hire-logos/react-native.webp",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image: "https://git-scm.com/images/logos/logomark-orange@2x.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSwZ8yf3JwTIlWxzc-yRjgQmKyI58b8ClKvzw&s",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/2815952264/7a5ebfb0-0508-48ab-be9a-31b36ba53f97-cover.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "",
    role: "Android Developer Intern",
    company: "Adgama Digital",
    date: "Mar 2024 - July 2024",
    desc: "Developed multiple applications for clients, achieving a 100% project completion rate ahead of schedule. By leveraging Jetpack Compose, Kotlin, API integrations, Firebase authentication, and Firestore, I enhanced app efficiency by 30%. In collaboration with a team of developers, I contributed to the delivery of high-quality applications, which resulted in a 25% increase in team productivity. My involvement spanned the full software development lifecycle, including requirements gathering, design, coding, testing, and deployment.",
    skills: [
      "Jetpack Compose",
      "Kotlin",
      "Firebase",
      "Firestore",
      "Retrofit",
      "Dagger-Hilt",
      "MVVM",
      "Room / SQLite database",
    ],
    doc: "",
  },
  {
    id: 1,
    img: "",
    role: "Android Developer Executive",
    company: "Adgama Digital",
    date: "July 2024 - Present",
    // desc: "Developed multiple applications for clients, achieving a 100% project completion rate ahead of schedule. By leveraging Jetpack Compose, Kotlin, API integrations, Firebase authentication, and Firestore, I enhanced app efficiency by 30%. In collaboration with a team of developers, I contributed to the delivery of high-quality applications, which resulted in a 25% increase in team productivity. My involvement spanned the full software development lifecycle, including requirements gathering, design, coding, testing, and deployment.",
    skills: [
      "Jetpack Compose",
      "Kotlin",
      "Firebase",
      "Firestore",
      "Retrofit",
      "Dagger-Hilt",
      "MVVM",
      "Room / SQLite database",
    ],
    doc: "",
  },
];

export const education = [
  {
    id: 0,
    img: "https://github.com/gh-shujauddin/public-images/assets/73093103/c80e0241-ef55-4bd5-94b0-f5e43e2f931a",
    school: "Vishveshwarya Groups of Institutions, Greater Noida",
    date: "Nov 2020 - June 2024",
    grade: "8.31 CGPA",
    desc: 'I graduated with a Bachelor\'s degree in Computer Science and Engineering from Vishveshwarya Groups of Institutions, Greater Noida, achieving a CGPA of 8.3. During my studies, I completed coursework in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks. I gained practical experience through various projects and assignments that allowed me to apply classroom knowledge to real-world problems. Notably, I secured the top 2 rank in URJIT 2022, an Open House Project presentation for the project "Digital Hostel" at my college.',
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://github.com/gh-shujauddin/portfolio/assets/73093103/f515ab18-35f8-44f1-ad14-c373935012fc",
    school: "Anand Valley Sr. Sec. School, Someshwar",
    date: "Apr 2019 - Apr 2020",
    grade: "85.6%",
    // desc: "I completed my class 12 high school education at Anand Valley Sr. Sec. School, Someshwar, where I studied Physics, Chemistry and Mathematics.",
    degree: "CBSE(XII), PCM",
  },
  {
    id: 2,
    img: "https://github.com/gh-shujauddin/portfolio/assets/73093103/f515ab18-35f8-44f1-ad14-c373935012fc",
    school: "Anand Valley Sr. Sec. School, Someshwar",
    date: "Apr 2017 - Apr 2018",
    grade: "90.6%",
    // desc: "I completed my class 10 education at Anand Valley Sr. Sec. School, Someshwar.",
    degree: "CBSE(X)",
  },
];

export const projects = [
  {
    id: 1,
    title: "Tripzy",
    date: "May 2024",
    description:
      "Tripzy is a Smart Travel Mobile Application that aims to provide details about the places to travel. User can plan new trip also where user will get curated list of places according to days which user can personalize.",
    image:
      "https://github.com/gh-shujauddin/Tripzy/assets/73093103/45329e04-95c7-4453-a004-9d153898ed28",
    tags: [
      "Jetpack Compose",
      "Palm API",
      "Here API",
      "Places API",
      "Mapbox",
      "Android",
    ],
    category: "android app",

    github: "https://github.com/gh-shujauddin/Tripzy",
    webapp: "https://github.com/gh-shujauddin/Tripzy",
    members: [
      {
        name: "Shujauddin Qadri",
        img: "https://avatars.githubusercontent.com/u/73093103?v=4",
        linkedin: "https://www.linkedin.com/in/shqadri",
        github: "https://www.github.com/gh-shujauddin",
      },
    ],
  },
  {
    id: 4,
    title: "Yam Eats",
    date: "Jan 2024 - Mar 2024",
    description:
      "Yam Eats is a mobile application built with React Native and AWS Amplify, allowing users to browse restaurants, add dishes to their baskets, place orders, and track live orders on a map.",
    image:
      "https://github.com/user-attachments/assets/e0e1d82b-4930-44a5-b64d-e331f72a5f56",
    tags: [
      "Android/IOS",
      "React Native",
      "React",
      "Ant Design",
      "Places API",
      "AWS Amplify",
    ],
    category: "cross-platform app",
    github: "https://github.com/gh-shujauddin/Yam-Eats",
    webapp: "https://github.com/gh-shujauddin/Yam-Eats",
    members: [
      {
        name: "Shujauddin Qadri",
        img: "https://avatars.githubusercontent.com/u/73093103?v=4",
        linkedin: "https://www.linkedin.com/in/shqadri",
        github: "https://www.github.com/gh-shujauddin",
      },
    ],
  },

  {
    id: 0,
    title: "Digital Hostel",
    date: "Nov 2022",
    description:
      "Digital Hostel is a web-based application designed to streamline and automate various activities in a hostel. The project aimed to create a platform that simplifies the management of the hostel for both hostel administrators and students.  The project's second prize win at URJIT: Open House Project Presentation is a testament to the team's hard work and dedication to delivering a high-quality websites.",
    image:
      "https://github.com/DeVerse4/Digital-Hostel/assets/73093103/39a392f6-d0a2-4c4b-9ea9-f371b6ddbdc9",
    tags: ["HTML", "CSS", "JavaScript", "BootStrap", "PHP", "MySQL"],
    category: "web app",
    github: "https://github.com/Deverse4/Digital-Hostel",
    webapp: "https://github.com/Deverse4/Digital-Hostel",
    members: [
      {
        name: "Shujauddin Qadri",
        img: "https://avatars.githubusercontent.com/u/73093103?v=4",
        linkedin: "https://www.linkedin.com/in/shqadri",
        github: "https://www.github.com/gh-shujauddin",
      },
      {
        name: "Ahmad Kamran",
        img: "https://avatars.githubusercontent.com/u/93698466?s=96&v=4",
        linkedin: "https://www.linkedin.com/in/ahmadkamran2",
        github: "https://www.github.com/kamran-2",
      },
      {
        name: "Gyan Prakash Kumar",
        img: "https://avatars.githubusercontent.com/u/100079802?s=64&v=4",
        linkedin: "https://www.linkedin.com/in/gyan-prakash-kumar",
        github: "https://www.github.com/krgyaan",
      },
      {
        name: "Pritam Kumar",
        img: "https://avatars.githubusercontent.com/u/101428620?s=70&v=4",
        linkedin: "https://www.linkedin.com/in/pritam1708/",
        github: "https://www.github.com/pritam1708",
      },
    ],
  },
  {
    id: 2,
    title: "Face Capture",
    date: "Sep 2023",
    description:
      "Crowd detection application which detects the number of faces on live camera. It uses ML Kit library to detect faces. It also tells the number of faces detected.",
    image:
      "https://github.com/gh-shujauddin/FaceCaptureApp/assets/73093103/3c8fc48b-b690-497c-a603-4b742f1b2bba",
    tags: ["Kotlin", "ML Kit", "CameraX", "Firebase", "Android"],
    category: "android app",
    github: "https://github.com/gh-shujauddin/FaceCaptureApp",
    webapp: "https://github.com/gh-shujauddin/FaceCaptureApp",
    members: [
      {
        name: "Shujauddin Qadri",
        img: "https://avatars.githubusercontent.com/u/73093103?v=4",
        linkedin: "https://www.linkedin.com/in/shqadri",
        github: "https://www.github.com/gh-shujauddin",
      },
    ],
  },
  {
    id: 3,
    title: "ChatBT",
    date: "Jun 2023 - Jul 2023",
    description:
      "A Simple Bluetooth Chat application built to demonstrate the use of modern android architecture component with MVVM Architecture and bluetooth services.",
    image:
      "https://github.com/gh-shujauddin/ChatBT/assets/73093103/6e475fcf-a95e-4d98-ad74-9d5265cc3ca7",
    tags: ["Android", "Kotlin", "MVVM", "Bluetooth", "Flow", "Jetpack Compose"],
    category: "android app",
    github: "https://github.com/gh-shujauddin/ChatBT",
    webapp: "https://github.com/gh-shujauddin/ChatBT",
    members: [
      {
        name: "Shujauddin Qadri",
        img: "https://avatars.githubusercontent.com/u/73093103?v=4",
        linkedin: "https://www.linkedin.com/in/shqadri",
        github: "https://www.github.com/gh-shujauddin",
      },
    ],
  },
  
];

export const TimeLineData = [
  { year: 2021, text: "Started Web Development" },
  { year: 2023, text: "Started Android Development" },
];
